const EVENTS = new Set([
  "room_created",
  "timezone_added",
  "room_link_copied",
  "participant_joined",
  "calendar_sync_started",
  "calendar_sync_completed",
  "calendar_sync_failed",
  "availability_submitted",
  "meeting_finalized",
  "google_calendar_clicked",
  "outlook_clicked",
  "feedback_submitted",
  "feedback_voted",
]);

export function track(event: string) {
  if (!EVENTS.has(event) || typeof fetch !== "function") return;
  void fetch("/api/events", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ event }),
    keepalive: true,
  }).catch(() => {
    /* ignore */
  });
}
